import { render } from "./adjustments-modal-footer-label.vue?vue&type=template&id=b28a2438"
const script = {}

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__